/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyAIAssistantOperatorListItemTypename = "PharmacyAIAssistantOperatorListItem" as const;

/**
 *
 * @export
 * @interface PharmacyAIAssistantOperatorListItem
 */
export interface PharmacyAIAssistantOperatorListItem {
  /**
   *
   * @type {string}
   * @memberof PharmacyAIAssistantOperatorListItem
   */
  authId: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyAIAssistantOperatorListItem
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyAIAssistantOperatorListItem
   */
  pharmacyId: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyAIAssistantOperatorListItem
   */
  readonly __typename?: string;
}

export function PharmacyAIAssistantOperatorListItemFromJSON(json: any): PharmacyAIAssistantOperatorListItem {
  return PharmacyAIAssistantOperatorListItemFromJSONTyped(json, false);
}

export function PharmacyAIAssistantOperatorListItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyAIAssistantOperatorListItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyAIAssistantOperatorListItemTypename,

    authId: json["auth_id"],
    id: json["id"],
    pharmacyId: json["pharmacy_id"],
  };
}

export function PharmacyAIAssistantOperatorListItemToJSON(object?: PharmacyAIAssistantOperatorListItem | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auth_id: value.authId,
    id: value.id,
    pharmacy_id: value.pharmacyId,
  };
}
